import React from "react"

import { useCheckList } from "./CheckListContext";

export default function CheckBoxField({rec, fld, label=null, unique=false, size=20}) {
    const {updateRec} = useCheckList()

    const changeHandler = (event) => {
        const newRec = Object.assign({}, rec, {[fld]: event.target.checked})
        updateRec(newRec)
    }

    return (
        <input 
            type="checkbox"
            name={fld}
            checked={rec[fld]}
            onChange={changeHandler}
        />
    )
}